import { createContext, useContext } from 'react'

export interface ThemeContextValue {
  isDark: boolean
  toggle: () => void
}

export const ThemeContext = createContext<ThemeContextValue | null>(null)

export function useAppTheme(): ThemeContextValue {
  const context = useContext(ThemeContext)

  if (!context) {
    throw new Error('useAppTheme must be used within ThemeContext.Provider')
  }

  return context
}
